import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Icon, type IDropdownItem, Tooltip, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const DocumentsSelectTrigger = observer(
  ({
    selectedDocuments,
    isSelectAllDocuments,
  }: {
    selectedDocuments: IDropdownItem[]
    isSelectAllDocuments: boolean
  }) => {
    const visibleItems = selectedDocuments.slice(0, 6)
    const tooltipItems = selectedDocuments.slice(6)

    if (!selectedDocuments.length) {
      return (
        <div className={styles.emptyWrap}>
          <Typography
            color={'var(--content-primary-tertiary)'}
            variant={'body-md-regular'}
            ariaLabel={'placeholder'}
          >
            Select documents
          </Typography>
        </div>
      )
    }

    if (isSelectAllDocuments) {
      return (
        <div className={styles.emptyWrap}>
          <Typography variant={'text-input-field-r'} ariaLabel={'allSelected'}>
            All documents selected
          </Typography>
        </div>
      )
    }

    return (
      <div className={classNames(styles.trigger)}>
        {visibleItems.map((item) => (
          <div className={styles.triggerContentWrap} key={item.id}>
            <>
              {item.iconL && <Icon icon={item.iconL} color={'var(--content-primary-tertiary)'} />}
              <div className={styles.info}>
                <Typography
                  ariaLabel={'documentName'}
                  color={'var(--content-primary-primary)'}
                  variant={'body-md-regular'}
                  ellipsis
                >
                  {item.label}
                </Typography>
              </div>
            </>
          </div>
        ))}
        {!!tooltipItems.length && (
          <Tooltip
            label={
              <div className={styles.tooltipItems}>
                {tooltipItems.map((item) => (
                  <div key={item.id}>{item.label}</div>
                ))}
              </div>
            }
            placement='top'
          >
            <div className={styles.remainderCount}>+{tooltipItems.length}</div>
          </Tooltip>
        )}
      </div>
    )
  }
)
